export default {
  methods: {
    scrollToHash(container?) {
      if (this.$router.currentRoute.hash) {
        $("body").trigger("scrollToHash", {
          hash: this.$router.currentRoute.hash,
          container: container
        });
      }
    }
  }
};
